import { Navigate } from "react-router-dom"
import { isAuthenticated } from "../api/auth"

/**
 * ProtectedRoute component - wraps routes that require authentication
 * Redirects to login if user is not authenticated
 */
export const ProtectedRoute = ({ element }) => {
  if (!isAuthenticated()) {
    console.log("[v0] Access denied: User not authenticated. Redirecting to login.")
    return <Navigate to="/admin/login" replace />
  }

  return element
}
